export default __webpack_public_path__ + "static/media/Inter-SemiBold.a62ce61f.ttf";